<script setup>
import { Head } from '@inertiajs/vue3'
import PublicLayout from '@/Layouts/PublicLayout.vue'
import { destinations } from '@/data/content.js'

defineOptions({ layout: PublicLayout })
</script>

<template>
  <Head>
    <title>Destinations · Kenya2Go</title>
    <meta name="description" content="From the Maasai Mara to the Swahili coast — Kenya’s regions and where to go.">
  </Head>

  <div class="kp">
    <header class="kp-hero">
      <div class="kp-hero__inner">
        <p class="kp-eyebrow">Where to go</p>
        <h1 class="kp-hero__title">From the plains to the sea</h1>
        <p class="kp-hero__lede">Kenya packs a continent into one country — big-cat plains, a snow-capped mountain, red northern desert, and a thousand-year-old coast. Start with the landscapes that move you.</p>
      </div>
    </header>

    <section class="kp-section">
      <div class="dgrid">
        <a v-for="d in destinations" :key="d.slug" class="kp-card dcard" :href="`/destinations/${d.slug}`" :style="{ '--h': d.hue }">
          <div class="kp-art dcard__art"></div>
          <div class="dcard__body">
            <p class="dcard__region">{{ d.region }}</p>
            <h2 class="dcard__name">{{ d.name }}</h2>
            <p class="dcard__blurb">{{ d.blurb }}</p>
            <span class="dcard__tag">{{ d.tag }} →</span>
          </div>
        </a>
      </div>
    </section>
  </div>
</template>

<style scoped>
.dgrid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 1.2rem; }
.dcard__art { height: 190px; }
.dcard__body { padding: 1.2rem 1.3rem 1.4rem; }
.dcard__region { font-size: 0.72rem; letter-spacing: 0.12em; text-transform: uppercase; color: var(--muted); font-weight: 600; margin: 0 0 0.35rem; }
.dcard__name { font-family: var(--display); font-weight: 500; font-size: 1.5rem; line-height: 1.05; margin: 0 0 0.5rem; color: var(--ink); }
.dcard__blurb { font-size: 0.92rem; line-height: 1.5; color: var(--inkSoft); margin: 0 0 0.8rem; }
.dcard__tag { font-size: 0.82rem; font-weight: 600; color: var(--accent); }
@media (max-width: 860px) { .dgrid { grid-template-columns: repeat(2, 1fr); } }
@media (max-width: 560px) { .dgrid { grid-template-columns: 1fr; } }
</style>
